<template>
  <section class="section" id="campos">
    <institution-detail></institution-detail>
  </section>
</template>

<script>
import InstitutionDetail from '@/components/admin/institutions/InstitutionDetail.vue'

export default {
  components: { InstitutionDetail },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style></style>
